let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("if06H")).then(() => parcelRequire('2vHc7'));